//General
import About from "@/views/About.vue";
import AddCard from "@/views/AddCard.vue";
import Carteira from "@/views/Carteira.vue";
import ChooseVoucher from "@/views/ChooseVoucher.vue";
import ContactEdit from "@/views/ContactEdit.vue";
import Extrato from "@/views/Extrato.vue";
import HomeFeed from "@/views/HomeFeed.vue";
import HomeLojas from "@/views/HomeLojas.vue";
import HomeRelease from "@/views/HomeRelease.vue";
import NewsDetails from "@/views/NewsDetails.vue";
import Notifications from "@/views/Notifications.vue";
import PaymentMethod from "@/views/PaymentMethod.vue";
import PerfilDelivery from "@/views/PerfilDelivery.vue";
import RegisteredCards from "@/views/RegisteredCards.vue";
import Vue from "vue";
import Router from "vue-router";

import Survey from "@/surveyfrontend/views/Survey.vue";
import Surveys from "@/surveyfrontend/views/Surveys.vue";
import AddSupportRequest from "@/views/AddSupportRequest.vue";
import SupportRequest from "@/views/SupportRequest.vue";
import SupportRequestDetails from "@/views/SupportRequestDetails.vue";

//Orders
import ExtratoPedido from "@/ordersfrontend/views/ExtratoPedido.vue";
import Lojas from "@/ordersfrontend/views/Lojas.vue";
import PedidosRealizados from "@/ordersfrontend/views/PedidosRealizados.vue";
import Produto from "./../node_modules/orders-module/src/views/ProdutoNovo.vue";

//Others
import AddAddress from "@/views/AddAddress.vue";
import LoginModal from "shared-components/LoginModal.vue";

const VueInputMask = require("vue-inputmask").default;
Vue.use(VueInputMask);

Vue.use(Router);

const router = new Router({ routes: [] });

export class SpecialRouter {
  static router = router;
  static guestRoutes: any = [
    "/",
    "/HomeFeed",
    "/ConfirmAccessCode",
    "/Lojas",
    "/Produtos",
    "/Produtos/:idStore",
    "/Produtos/:idStore/:idTable",
    "/Produto",
    "/RecoverPassword",
    "/Register",
    "/ConfirmRecoverCode",
    "/AddAddress",
    "/DeliverLocation",
    "/Pedido",
    "/VerPedido",
    "/NewsDetails",
    "/Comanda",
    "/PayTotalValue",
    "/PayHalfValue",
    "/HomeRelease",
    "/LerQrMesa",
    "/QrcodeReader",
    "/QrcodeReaderApp",
    "/HomeLojas",
    "/ListaDeProdutos",
    "/BarCodeProduct",
    "/ScheduleOrder",
  ];

  static addRoutes(routesArray: any) {
    const loginModal: any = LoginModal;
    SpecialRouter.router.addRoutes(
      routesArray.map((route: any) => {
        return {
          ...route,
          beforeEnter: (to: any, from: any, next: any) => {
            if (sessionStorage.getItem("USE_INTEGRATION") != "true") {
              if (
                sessionStorage.getItem("USER_ID") ||
                SpecialRouter.guestRoutes.includes(route.path)
              ) {
                if (route.beforeEnter) route.beforeEnter(to, from, next);
                else next();
              } else {
                sessionStorage.setItem("LOGIN_CALLBACK", JSON.stringify(to));
                loginModal.openLoginModal();
              }
            } else if (route.beforeEnter) route.beforeEnter(to, from, next);
            else next();
          },
        };
      })
    );
  }
}

SpecialRouter.addRoutes([
  {
    path: "/NewsDetails",
    name: "NewsDetails",
    component: NewsDetails,
  },
  {
    path: "/Carteira",
    name: "Carteira",
    component: Carteira,
  },
  {
    path: "/Extrato",
    name: "Extrato",
    component: Extrato,
  },
  {
    path: "/RegisteredCards",
    name: "RegisteredCards",
    component: RegisteredCards,
  },
  {
    path: "/AddCard",
    name: "AddCard",
    component: AddCard,
  },
  {
    path: "/HomeFeed",
    name: "HomeFeed",
    component: HomeFeed,
  },
  {
    path: "/HomeRelease",
    name: "HomeRelease",
    component: HomeRelease,
  },
  {
    path: "/HomeLojas",
    name: "HomeLojas",
    component: HomeLojas,
  },
  {
    path: "/Lojas",
    name: "Lojas",
    component: Lojas,
  },
  {
    path: "/About",
    name: "About",
    component: About,
  },
  {
    path: "/PaymentMethod",
    name: "PaymentMethod",
    component: PaymentMethod,
  },
  {
    path: "/PerfilDelivery",
    name: "PerfilDelivery",
    component: PerfilDelivery,
  },
  {
    path: "/SupportRequest",
    name: "SupportRequest",
    component: SupportRequest,
  },
  {
    path: "/AddSupportRequest",
    name: "AddSupportRequest",
    component: AddSupportRequest,
  },
  {
    path: "/SupportRequestDetails",
    name: "SupportRequestDetails",
    component: SupportRequestDetails,
  },
  //Orders
  {
    path: "/PedidosRealizados",
    name: "PedidosRealizados",
    component: PedidosRealizados,
  },
  {
    path: "/ExtratoPedido",
    name: "ExtratoPedido",
    component: ExtratoPedido,
  },
  {
    path: "/Notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/AddAddress",
    name: "AddAddress",
    component: AddAddress,
  },
  {
    path: "/Surveys",
    name: "Surveys",
    component: Surveys,
  },
  {
    path: "/Survey",
    name: "Survey",
    component: Survey,
  },
  {
    path: "/ContactEdit",
    name: "ContactEdit",
    component: ContactEdit,
  },
  {
    path: "/ChooseVoucher",
    name: "ChooseVoucher",
    component: ChooseVoucher,
  },
  {
    path: "/Produto",
    component: Produto,
    name: "Produto",
    beforeEnter: (to: any, from: any, next: any) => {
      if (from.name == "Produtos") {
        sessionStorage.setItem("ENTERED_FROM_PRODUCTS", "true");
        next();
      } else if (from.name == "HomeFeed") {
        sessionStorage.setItem("ENTERED_FROM_HOME_FEED", "true");
        next();
      } else {
        sessionStorage.removeItem("ENTERED_FROM_PRODUCTS");
        sessionStorage.removeItem("ENTERED_FROM_HOME_FEED");
        next();
      }
    },
  },
]);

export default router;
